import RegisterComponent from "./RegisterComponent";

export default RegisterComponent;
